<template>
  <PanelItem :index="index" :field="field">
    <template #value>
      <ol v-if="questions.length" class="sqd">
        <li v-for="(q, i) in questions" :key="i" class="sqd-row">
          <div class="sqd-prompt">{{ q.prompt }}</div>
          <div class="sqd-meta">
            <span class="sqd-type">{{ typeLabel(q.type) }}</span>
            <span v-if="!q.required" class="sqd-optional">اختیاری</span>
          </div>
          <div v-if="q.options && q.options.length" class="sqd-options">
            <span v-for="(o, oi) in q.options" :key="oi" class="sqd-option">{{ o }}</span>
          </div>
        </li>
      </ol>
      <p v-else>—</p>
    </template>
  </PanelItem>
</template>

<script>
export default {
  props: ['index', 'resource', 'resourceName', 'resourceId', 'field'],

  computed: {
    /**
     * The questions as the field resolved them.
     */
    questions() {
      return Array.isArray(this.field.value) ? this.field.value : []
    },
  },

  methods: {
    /**
     * Human label for a question type.
     */
    typeLabel(value) {
      const match = (this.field.types || []).find(t => t.value === value)
      return match ? match.label : value
    },
  },
}
</script>

<style scoped>
.sqd { display: flex; flex-direction: column; gap: 0.6rem; }
.sqd-row { border-inline-start: 3px solid rgba(var(--colors-primary-500), 0.5); padding-inline-start: 0.6rem; }
.sqd-prompt { font-weight: 600; }
.sqd-meta { display: flex; gap: 0.5rem; font-size: 0.8rem; opacity: 0.7; }
.sqd-options { display: flex; flex-wrap: wrap; gap: 0.35rem; margin-top: 0.25rem; }
.sqd-option {
  font-size: 0.78rem; padding: 0.1rem 0.5rem; border-radius: 999px;
  background: rgba(var(--colors-gray-200), 0.8);
}
</style>
